import React, { memo } from 'react';
import { Card, Skeleton, Stack } from 'investira.react.components';

/** Representa o carregamento com as mesmas proporções do card de indicador. */
const IndicadoresItemSkeleton = memo(() => (
  <Card>
    <Stack px={2} py={2} spacing={2} height="100%">
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1}>
        <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rounded" width={72} height={24} />
      </Stack>
      <Stack spacing={0.75}>
        <Skeleton variant="text" width="45%" height={20} />
        <Skeleton variant="text" width="85%" height={18} />
      </Stack>
    </Stack>
  </Card>
));

IndicadoresItemSkeleton.displayName = 'IndicadoresItemSkeleton';

export default IndicadoresItemSkeleton;
